document.addEventListener('DOMContentLoaded', () => {

  const ConteDetail = document.querySelector('.conte-detail');
  const templatePage = document.querySelector('.template-page');


  ScrollTrigger.create({
    trigger: ConteDetail, // スクロールで表示されるDOM要素
    start: 'top 66%', // 発動位置
    end: 'bottom -150%',
    toggleClass: { targets: templatePage, className: 'scrolled' }, // クラスの付与と削除
    markers: false, // GSAPのデバッグマーカーの表示/非表示
  });
});
